export const TextareaPanelType = {
	edit: 'edit',
	reply: 'reply',
	forward: 'forward',
	market: 'market',
	none: '',
};

// input field an insert event is addressed to; absence of the address means the main field
export const TextareaTarget = {
	main: 'main',
	uploadCaption: 'uploadCaption',
};
